module.exports = __webpack_public_path__ + "img/qiwi.065d7270.svg";